import { appUrl, pathHasAppEquivalent } from '~/lib/url'

export const redirectToAppIfRequired = (path: string, userIsLoggedIn: boolean) => {
  if (pathHasAppEquivalent(path) && userIsLoggedIn) {
    window.location.href = appUrl(path)
  }
}

